import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfluencerAnalyticsComponent } from './influencer-analytics.component';
import { InfluencerAnalyticsRoutingModule } from './influencer-analytics-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
@NgModule({
  declarations: [
    InfluencerAnalyticsComponent,
  ],
  imports: [
    CommonModule,
    InfluencerAnalyticsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule
  ]
})

export class InfluencerAnalyticsModule { 

}
